import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/data-connector/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import CustomLoader from '../common/CustomLoader';
import { prepareValidationForXataTables } from './common/common_utils';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';

export class XataTableCreation extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    externalDatabase: null,
  };

  async componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version, dbUuid } = match.params;
    await actions.loadExternalDatabaseForXata({ projectId, version, dbUuid });
    this.setState({ externalDatabase: this.props.dataConnector.externalDatabaseXata });
  }

  handleSendRequset = async (values) => {
    const { tableName, branchName } = values;
    const { actions, match, history } = this.props;
    const { projectId, version, dbUuid } = match.params;
    const { externalDatabase } = this.state;
    const { setting, completeData } = externalDatabase;
    const { database } = completeData;
    const { workspaceId, name, region } = database;
    const dataForRequest = {
      projectId,
      version,
      tableName,
      branchName,
      workspaceId,
      region,
      databaseName: name,
      headers: setting,
    };
    await actions.getSchemaForXataCollection(dataForRequest);
    if (this.props.dataConnector.schemaForXata) {
      const { schemaForXata } = this.props.dataConnector;
      const fields = schemaForXata.reduce((obj, item) => {
        obj[item.name] = item.type;
        return obj;
      }, {});
      const dataForUpdate = {
        projectId,
        version,
        tableName,
        dbUuid,
        fields: fields,
        branch: branchName ? branchName : '',
      };
      await actions.updateTableAndFieldsForXata(dataForUpdate);
      this.props.history.push(
        `/2.0/data-connector/${version}/v/${projectId}/xata/${dbUuid}/${tableName}`,
      );
    }
  };

  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />;
        </CommonPageComponent>
      );
    }

    const { dataConnector } = this.props;
    const { getSchemaForXataCollectionPending } = dataConnector;
    const { externalDatabase } = this.state;
    const completeData = externalDatabase ? externalDatabase.completeData : null;
    const databaseName = completeData ? completeData.database.name : null;
    return (
      <CommonPageComponent>
        <ParentContentCard title={'Database for Collection creation'} icon="collection">
          <Formik
            initialValues={{
              tableName: '',
              branchName: '',
            }}
            validationSchema={prepareValidationForXataTables}
            onSubmit={(values) => {
              this.handleSendRequset(values);
            }}
          >
            {({ values, handleChange, setFieldValue }) => (
              <Form className="form-row">
                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                  <div className="form-row justify-content-center">
                    <div className="col-sm-3">
                      <label>
                        <b>Database Name :</b>
                      </label>
                    </div>
                    <div className="col-sm-3">
                      <label>
                        <b>{databaseName}</b>
                      </label>
                    </div>
                  </div>
                  <div className="form-row mb-3 mt-3 justify-content-center">
                    <div className="col-sm-3">
                      <label>
                        <b>Table Name :</b>
                      </label>
                    </div>
                    <div className="col-sm-3">
                      <Field
                        type="text"
                        name="tableName"
                        className="form-control form-control-sm"
                        placeholder="Enter Table Name"
                      />
                      <ErrorMessage name="tableName" component="p" className="text-danger" />
                    </div>
                  </div>
                  <div className="form-row mb-3 mt-3 justify-content-center">
                    <div className="col-sm-3">
                      <label>
                        <b>Branch Name :</b>
                      </label>
                    </div>
                    <div className="col-sm-3">
                      <Field
                        type="text"
                        name="branchName"
                        className="form-control form-control-sm"
                        placeholder="Enter Branch Name if not Main"
                      />
                      <ErrorMessage name="branchName" component="p" className="text-danger" />
                    </div>
                  </div>
                  <div className="form-row justify-content-center mt-5">
                    <div className="col-sm-7 text-right mr-4">
                      <button
                        type="submit"
                        className="btn btn-theme-submit btn-md"
                        title="Save & Continue"
                        disabled={getSchemaForXataCollectionPending}
                      >
                        <i className="wb webconnect-save-regular"></i> Save & Continue
                        <CustomLoader loading={getSchemaForXataCollectionPending} />
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </ParentContentCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(XataTableCreation);
